/**
 * OpenApp: merchantPanel
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PublicKeyCredentialType = {
    PublicKey: 'public-key'
} as const;
export type PublicKeyCredentialType = typeof PublicKeyCredentialType[keyof typeof PublicKeyCredentialType];

